import api from './index'

const resource = 'message_attachments'

export default {
  getAttachment (id) {
    return api.get(`${resource}/${id}/download`, { responseType: 'arraybuffer' })
  }
}
